import { render, staticRenderFns } from "./OutboundList.vue?vue&type=template&id=b9f92730&scoped=true&"
import script from "./OutboundList.vue?vue&type=script&lang=js&"
export * from "./OutboundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f92730",
  null
  
)

export default component.exports